// 报警API
import request from '@/utils/request'

/**
 * 根据查询条件, 分页获取报指定项目的报警信息列表
 * @param params
 * @param data
 * @returns {*}
 */
export function alertList(params,data) {
    return request({
        url: '/alert-info/public/'+data.pid,
        method: 'post',
        data,
        params
    })
}

